module.exports = __webpack_public_path__ + "static/media/lucifer-cannon.34d680ef.svg";